export class BillingOverviewDTO {

   currency: string;

   phoneSupport: boolean;

   nextBillingDate: string;

   vat: {

      added: boolean;

      percentage: number;

      total: number;

   };

   counts: {

      users: number;

      appNotifications: number;

      emailNotifications: number;

      smsNotifications: number;

      storage: number;

   };

   prices: {

      abilities: {

         monthly: number;

         yearly: number;

      };

      appNotifications: number;

      emailNotifications: number;

      smsNotifications: number;

      storage: number;

      phoneSupport: number;

   };

   totals: {

      amount: number;

      vat: number;

      users: number;

      app: number;

      sms: number;

      storage: number;

   };

}
